import React from 'react'
import { Box, useTheme, Button, Typography, Stack, Link } from "@mui/material";
import { tokens } from "../../../assets/theme";
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import CountdownTimer from "./countdownTimer";
import { FormattedMessage } from "react-intl";
import messages from "./../messages";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export default function AlarmBanner(props) {
    const { alarms, handleCancelAutocodeClick } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const distinctMacines = alarms.filter((alarm, index, self) =>
        index === self.findIndex((t) => t.machine.id === alarm.machine.id)
    );

    return (
        <Box
            sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                paddingLeft: "20px",
                paddingRight: "20px",
                direction: "row",
                backgroundColor: "#FF6F00",
            }}
        >
            <Stack spacing={1} direction="row" sx={{ }} display="flex" alignItems="center">
                <NotificationsActiveIcon sx={{ color: "#fff", fontSize: 20 }} />
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px', marginLeft: '20px'}}
                >
                    <FormattedMessage {...messages.alarm} />
                </Typography>

                <Box width="20px"></Box>
                {distinctMacines.map((alarm, index) => (
                    <Box sx={{
                        borderRadius: "4px",
                        backgroundColor: colors.primary[500],
                        padding: "7px",
                        paddingRight: "20px",
                        paddingLeft: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        
                    }}>
                        <Typography variant="inherit" sx={{ fontSize: '14px' }} textAlign="center">
                            <Link href={`/machines/${alarm?.machine?.id}?tab=4`} sx={{color: '#fff', fontSize: 16 }}>{alarm?.machine?.machineName}</Link>
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Box>
    )
}